// application.js
const da = require('json!yaml!././da.yml')
const da2 = require('json!yaml!./da2.yml')
da.da.vue2 = da2

export default da



// WEBPACK FOOTER //
// ./src/i18n/da.js